
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';
import { getVymeraStringWithUnit } from '../../common/common/iskn/vymera';

import mapGetActions from '../../sagas/map';
import selectionGetActions from '../../sagas/selection';
import { getToken } from '../../reducers/auth';
import { getProjectId } from '../../reducers/project';
import ObjectInfoTitle from './ObjectInfoTitle';
import LinkToParcela from './LinkToParcela';
import ToolbarCommandButton from './ToolbarCommandButton';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 500
    },
    parcelaKatuzeNazev: {
        width: 150
    },
    parcelaCislo: {
        width: 100
    },
    parcelaVymera: {
    }
});

const ObjectInfoParcelaItem = (props) => {
    return (
        <Stack horizontal>
            <Stack.Item className={classNames.parcelaKatuzeNazev}>
                {props.item.katuze_nazev}
            </Stack.Item>
            <Stack.Item className={classNames.parcelaCislo}>
                <LinkToParcela parc={props.item} />
            </Stack.Item>
            <Stack.Item className={classNames.parcelaVymera}>
                {getVymeraStringWithUnit(props.item.vymera_parcely)}
            </Stack.Item>
        </Stack>
    );
}

const ListInfo = (props) => {

    const handleClick = () => {
        if (props.onShowAllClick) {
            props.onShowAllClick();
        }
    }

    if (props.onlyInList) {
        if (props.parc.length > props.parcInList.length) {
            return (
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <Text>zobrazení parcel ze seznamu ({props.parcInList.length}) -</Text>
                    <Link onClick={handleClick}>zobrazit vše ({props.parc.length})</Link>
                </Stack>
            );
        }
        if (props.parc.length === props.parcInList.length) {
            return <Text>všechny parcely jsou v seznamu ({props.parc.length})</Text>;
        }
    } else {
        return <Text>zobrazuji všechny parcely ({props.parc.length})</Text>;
    }
}

const ObjectInfoParcely = (props) => {

    const [onlyInList, setOnlyInList] = useState(props.onlyInList !== false);

    const dispatch = useDispatch();
    const mapActions = mapGetActions(dispatch);
    const selectionActions = selectionGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));

    let parcInList = props.parc.filter(item => {
        return (item.in_list === 1);
    });

    let parc = onlyInList ? parcInList : props.parc;

    useEffect(() => {
        // ToDo: do it better
        setTimeout(
            () => {
                let geoJsons = parc.map(item => {
                    return item.geom;
                }).filter(item => !!item);

                mapActions.addCommand(
                    'HIGHLIGHT_FEATURE',
                    {
                        geoJson: null,
                        geoJsons: geoJsons,
                        zoomToFeature: false
                    }
                );
            },
            1000
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.parc, onlyInList]);

    const handleFilterClick = () => {
        selectionActions.selectionFilter(token, projectId, [parc.map(item => item.id)]);
    }

    const handleReplaceClick = () => {
        selectionActions.selectionReplace(token, projectId, [parc.map(item => item.id)]);
    }

    const handleSelectClick = () => {
        selectionActions.selectionAdd(token, projectId, [parc.map(item => item.id)]);
    }

    const handleUnselectClick = () => {
        selectionActions.selectionRemove(token, projectId, [parc.map(item => item.id)]);
    }

    return (props.parc.length > 0)
        ? <Stack verticalfill>
            {(props.titleVisible !== false)
                ? <Stack.Item>
                    <ObjectInfoTitle
                        title={props.title}
                        content={(
                            <ListInfo
                                parc={props.parc}
                                parcInList={parcInList}
                                onlyInList={onlyInList}
                                onShowAllClick={() => setOnlyInList(false)}
                            />
                        )}
                    />
                </Stack.Item>
                : null
            }
            <Stack.Item grow className={classNames.list}>
                {(parc.length > 0)
                    ? parc.map(item => {
                        return (
                            <ObjectInfoParcelaItem key={item.id} item={item} />
                        )
                    })
                    : <Text>seznam je prázdný</Text>
                }
            </Stack.Item>
            <Stack.Item>
                {(parc.length > 0)
                    ? <ToolbarCommandButton items={[
                        {
                            text: 'Vybrat',
                            title: 'Přidat parcely do vybraných',
                            onClick: handleSelectClick
                        },
                        {
                            text: 'Vybrat z výběru',
                            title: 'Filtrovat parcely ve výběru',
                            onClick: handleFilterClick
                        },
                        {
                            text: 'Nahradit výběr',
                            title: 'Nahradit parcely ve výběru aktuálními parcelami',
                            onClick: handleReplaceClick
                        },
                        {
                            text: 'Odvybrat',
                            title: 'Odstranit parcely z vybraných',
                            onClick: handleUnselectClick
                        }
                    ]}/>
                    : null
                }
            </Stack.Item>
        </Stack>
        : null;
}

export default ObjectInfoParcely;
